import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const navList = [
    {
      id: 1,
      list: "Home",
    },
    {
      id: 2,
      list: "About",
    },
    {
      id: 3,
      list: "Portfolio",
    },
    {
      id: 4,
      list: "Experience",
    },
    {
      id: 5,
      list: "Contact",
    },
  ];

  return (
    <div className="flex justify-between items-center w-full h-20 text-white fixed bg-black px-4 z-10">
      <div>
        <h1 className="text-5xl font-signature ml-2 text-gray-500 hover:text-cyan-300 cursor-grab">
          Houssem
        </h1>
      </div>

      <ul className="hidden md:flex">
        {navList.map((navList) => (
          <li
            key={navList.id}
            className="px-4 cursor-pointer font-medium text-gray-500 hover:scale-105 duration-200 hover:text-cyan-300"
          >
            <Link to={navList.list} smooth duration={600}>
              {navList.list}
            </Link>
          </li>
        ))}
      </ul>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-cyan-300">
          {navList.map((navList) => (
            <li key={navList.id} className="px-4 cursor-pointer py-6 text-4xl">
              <Link
                onClick={() => setNav(!nav)}
                to={navList.list}
                smooth
                duration={600}
              >
                {navList.list}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Navbar;
